module.exports = __webpack_public_path__ + "img/spe2.d71e8b45.jpg";